export default __webpack_public_path__ + "static/media/loginPage.65c845a4.png";